// Linked before the checklist existed. A published post at the same slug
// is served instead; this only applies when that post is missing.
const retiredBlogRedirects: Record<string, string> = {
  'first-time-landlord-checklist': 'new-landlord-rules-2026',
};

export const getRetiredBlogRedirect = (slug: string) =>
  retiredBlogRedirects[slug];
